var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    fillRule: "evenodd",
    d: "M16.67 6.53v-1.4c0-.07-.13-.13-.28-.13H3.6c-.15 0-.28.06-.28.14v1.39c0 .07.13.14.28.14h12.8c.15 0 .28-.07.28-.14Zm0 2.78v1.38c0 .08-.13.14-.28.14H3.6c-.15 0-.28-.06-.28-.14V9.31c0-.08.13-.14.28-.14h12.8c.15 0 .28.06.28.14Zm0 4.16v1.4c0 .07-.13.13-.28.13H3.6c-.15 0-.28-.06-.28-.14v-1.39c0-.07.13-.14.28-.14h12.8c.15 0 .28.07.28.14Z",
    clipRule: "evenodd"
  })));
};
export default SvgMenu;